// extracted by mini-css-extract-plugin
module.exports = {"suggestionsItem":"SuggestionList_suggestionsItem__NHRJK"};